<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Cupcake</h1>
          <figure class="image">
            <img src="static/images/cupcake/cupcake_01--highres.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">Cupcake is a compact and comfortable swiveling lounge chair with a playful character.
          </p>
          <p>
            Designed for public and private spaces. Produced by Interface, Finland
          </p>
          <br>
          <p>Photography: Martti Järvi</p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/cupcake/cupcake_02.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/cupcake/cupcake_03.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default')
  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Cupcake.vue